// extracted by mini-css-extract-plugin
export default {"portalPopupOverlay":"PortalDrawer_portalPopupOverlay__IadKT"};